import React from "react";
import ReactECharts from "echarts-for-react";
import { useDarkMode } from "../../../hooks/useDarkMode";

const COLORS = [
  "#ff8787",
  "#ff5252",
  "#fa5252",
  "#e03131",
  "#ffc078",
  "#ffa94d",
  "#ff922b",
  "#f76707",
  "#a5d8ff",
  "#74c0fc",
  "#4dabf7",
  "#1c7ed6",
  "#ced4da",
  "#adb5bd",
  "#868e96",
  "#495057",
  "#96f2d7",
  "#63e6be",
  "#38d9a9",
  "#20c997",
  "#b2f2bb",
  "#8ce99a",
  "#69db7c",
  "#51cf66",
  "#f0abfc",
  "#e599f7",
  "#da77f2",
  "#cc5de8",
  "#ffe066",
  "#ffd43b",
];

export default function PowderPieChart({ data }) {
  const isDarkMode = useDarkMode();
  const textColor = isDarkMode ? "#ffffff" : "#111827";
  const tooltipBgColor = isDarkMode ? "#111827" : "#f3f4f6";

  const sorted = [...data].sort((a, b) => b.Percentage - a.Percentage);

  const chartOptions = {
    backgroundColor: "transparent",
    title: {
      text: "Composition",
      left: "center",
      textStyle: { color: textColor },
      subtextStyle: { color: textColor },
    },
    tooltip: {
      trigger: "item",
      backgroundColor: tooltipBgColor,
      textStyle: { color: textColor },
      formatter: "{b}: {c}% ({d}%)",
    },
    legend: {
      type: "scroll",
      orient: "vertical",
      right: 10,
      top: 20,
      bottom: 20,
      textStyle: { color: textColor },
      data: sorted.map((item) => item.Symbol),
    },
    series: [
      {
        name: "Symbol",
        type: "pie",
        radius: "55%",
        center: ["40%", "50%"],
        data: sorted.map((item, i) => ({
          value: item.Percentage,
          name: item.Symbol,
          itemStyle: { color: COLORS[i % COLORS.length] },
        })),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        label: {
          color: textColor,
          formatter: "{b}: {c}%",
        },
      },
    ],
  };

  return (
    <div
      className="w-full flex flex-col items-center"
      style={{ height: "320px" }}
    >
      <div className="w-[520px] max-w-full p-2 h-full align-middle items-center">
        {data && data.length > 0 && <ReactECharts option={chartOptions} />}
      </div>
    </div>
  );
}
